import axios from "axios";
import { alertSuccess } from "../../utils/feedback";
import { SET_AVATARS } from "../types/avatarsTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import axiosInstance from "../../axios";

export const setAvatars = (items) => ({
  type: SET_AVATARS,
  payload: items,
});

export const fetchAvatars = () => {
  return async (dispatch) => {
    try {
      const res = await axiosInstance.get(`/model/avatars`);
      const items = res.data.filter(
        (el) =>
          el !==
          "https://cytailor-static-website.s3.eu-west-3.amazonaws.com/Avatar/default_avatar.png"
      );
      dispatch(setAvatars(items));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
